import { Component, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../state/app.state';
import { selectCruce } from '../../state/selectors/cruce.selectors';
import { selectBtnRapido } from '../../state/selectors/btnRapido.selectors';
import { Cruce, BtnRapido, TipoVehiculo, SubtipoCruce } from '../../models';
import { addCruceClasificacion, addCruceObservacion, clearCruce } from '../../state/actions/cruce.actions';
import { addBtnRapidoClasificacion, addBtnRapidoObservacion, postBtnRapido } from '../../state/actions/btnRapido.actions';
import { postCruce } from '../../state/actions/cruce.actions';
import { TYPE_CRUCE, TYPE_BTNS, TYPE_CRUCE_PADRE, TYPE_PERMISO } from '../../utils/enum';
import { loadTipoVehiculo } from 'src/app/state/actions/tipoVehiculo.actions';
import { selectTipoVehiculo } from 'src/app/state/selectors/tipoVehiculo.selectors';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { selectPermisos } from 'src/app/state/selectors/caseta.selectors';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SolicitudesService } from 'src/app/services/solicitudes.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-no-evento',
    templateUrl: './no-evento.component.html',
    styleUrls: ['./no-evento.component.scss']
})
export class NoEventoComponent implements OnInit {
    monitoringFailures: SubtipoCruce[] = [];
    cruce: any = null;
    user: any = null;
    btnRapido: any = null;
    confirmModal: boolean = false;
    valorIngresado: string = '';

    constructor(private store: Store<AppState>,
        private router: Router,
        private toastr: ToastrService,
        private renderer: Renderer2,
        private solicitudesService: SolicitudesService,
        private ngxService: NgxUiLoaderService) { }

    ngOnInit(): void {

        this.getCruce()

        this.store.select(selectUser).subscribe(user => this.user = user);

        this.store.select(selectBtnRapido).subscribe(btnRapido => this.btnRapido = btnRapido);
        console.log(this.btnRapido);
        if (this.cruce.idPadre == 38) {

            this.monitoringFailures =
                JSON.parse(localStorage.getItem('monitoringFailures') || '[]');

        }
        console.log(this.monitoringFailures);

    }
    getCruce() {
        this.store.select(selectCruce).subscribe(cruce => this.cruce = cruce);
        console.log(this.cruce);
    }

    onChangeTN(e: string) {
        this.valorIngresado = e || '';
    }

    async confirmar(value: string) {
      console.log('Valor confirmado:', value || this.valorIngresado);
      const fecha = moment().format('YYYY-MM-DD HH:mm:ss');
      for (const falla of this.monitoringFailures) {
          const cruce: Cruce = {
              fecha_hora: fecha,
              id_corte_usuario: this.user.id_corte_usuario,
              id_subtipo: this.cruce.idChildren,
              id_clasificacion: this.cruce.id_clasificacion,
              fallas: [falla],
              no_sgp: this.valorIngresado,
          };
          this.store.dispatch(postCruce({ cruce }));
          // Esperar 2 segundos
          await new Promise(resolve => setTimeout(resolve, 200));
      }
      this.finishEvent();
  }

    finishEvent() {
      this.toastr.success('Cruce guardado con éxito', '', { positionClass: 'toast-bottom-right' })
      this.router.navigate(['/mopa/home']);
      this.store.dispatch(clearCruce());

    }
}
